import React from 'react';
import { ButtonClean } from '@fourthwall/components';
import * as S from './SpotifyUrlHelp.styled';
export const SpotifyUrlHelp = () => (React.createElement(S.Container, null,
    React.createElement(S.Header, null, "How to find your podcast\u2019s Spotify URL:"),
    React.createElement(S.List, null,
        React.createElement("li", null,
            "Go to",
            ' ',
            React.createElement(ButtonClean, { label: "Spotify\u2019s Podcast page", withUnderline: true, href: "https://open.spotify.com/genre/podcasts-page", target: "_blank" })),
        React.createElement("li", null, "Use the Search bar to search for your podcast"),
        React.createElement("li", null,
            "Select your podcast in the search results and copy the URL",
            React.createElement(S.Example, null, "Example, https://open.spotify.com/show/7Fj0XEuUQLUqoMZQdsLXqp")))));
